import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { transferableState } from "./utilities";

const responseSchema = yup.array().of(
  yup.object({
    id: yup.number().required(),
    state: yup.object().nullable(),
    user_id: yup.number().required(),
  }),
);

const responseAdapter = (data = []) => {
  return data.map((x) => ({
    ...x,
    state: transferableState.decode(x.state),
  }));
};

export const useFormStatesQuery = (options = {}) => {
  return useQuery(
    [QUERY_KEYS.formStates.all],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.formStates.get());
      return responseSchema.validateSync(responseAdapter(res?.data?.data), {
        strict: true,
      });
    },
    options,
  );
};
